import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=843675ca&scoped=true"
import script from "./AdminCompanies.vue?vue&type=script&lang=js"
export * from "./AdminCompanies.vue?vue&type=script&lang=js"
import style0 from "./AdminCompanies.vue?vue&type=style&index=0&id=843675ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843675ca",
  null
  
)

export default component.exports